import { environment } from './../../../environment/environment';
import { TutoService } from './../../core/services/tuto/tuto.service';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { serverError } from './../../core/models/messages';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-tuto-esn',
  templateUrl: './tuto-esn.component.html',
  styleUrls: ['./tuto-esn.component.css'],
})
export class TutoEsnComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  listTuto: any[] = [];
  loadSpinner: boolean = false;
  loadSpinnerTable: boolean = false;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  /* pagination */
  totalItems: number = 10;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  startIndex: number = 0;
  endIndex: number = 10;

  showFullDescription = false;
  showFullText: any;
  maxLength = 40;
  safeUrl!: SafeResourceUrl;
  displayURL: any;

  /*videoLinks*/
  videoLinks: string[] = [];
  intervalId: any;
  newListTuto: any;
  currentVideoIndex = 0;
  isVideoPlaybackInProgress = false;
  getTutoState = false;
  howFullText: boolean[] = [];
  pagination : boolean =false;

  currentPlayingVideo: number | null = null;
  url: string = environment.baseUrl + '/api/Tuto/file/tutosFiles/';

  startSearching:boolean = false;

  constructor(
    private tutoService: TutoService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.loadSpinnerTable = true;
    if (!this.getTutoState) {
      this.getListTuto();
    }
  }

  getListTuto() {
    const params = {
      per_page: this.pageSize,
      page: this.currentPage}   
    this.spinner.show();
    this.tutoService
      .getAllTuto(params)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.getTutoState = true;

            this.totalItems = res.data.total;
            this.listTuto = res.data.data
            // .slice(0, this.endIndex);
            // this.listTuto = res.data.data.reverse().slice(0, this.endIndex)

            this.showFullText = new Array(this.listTuto.length).fill(false);

            if (this.listTuto.length) {
              this.listTuto.forEach((element: any) => {
                this.videoLinks.push(element.link);
              });
            }

            this.listTuto = this.listTuto.map((item) => ({
              ...item,
              show_video: false,
            }));
          }
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
        error: (err: Error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
      });
  }

  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }

  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          
          this.pagination = true
        this.getListTuto();
        }
    }
  }


  displayVideo(link: string, index: number) {
    const videoId = this.getVideoIdFromURL(link);
    // Create the embedded YouTube URL
    const displayURL = `https://www.youtube.com/embed/${videoId}`;
    this.listTuto[index].displayURL =
      this.sanitizer.bypassSecurityTrustResourceUrl(displayURL);
    this.isVideoPlaybackInProgress = false;
  }

  private getVideoIdFromURL(url: string): string {
    const match = url.match(/v=([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      return match[1];
    }
    return '';
  }

  showVideo(link: any, index: any) {
    if (this.currentPlayingVideo !== null) {
      // Check if there's a currently playing video
      this.stopVideo(this.currentPlayingVideo);
    }

    const videoId = this.getVideoIdFromURL(link);
    const displayURL = `https://www.youtube.com/embed/${videoId}`;
    this.listTuto[index].displayURL =
      this.sanitizer.bypassSecurityTrustResourceUrl(displayURL);
    this.listTuto[index].show_video = true;

    this.currentPlayingVideo = index;
  }

  stopVideo(index: number) {
    // Check if the video at the specified index is playing and stop it
    if (this.listTuto[index].show_video) {
      this.listTuto[index].show_video = false;
      this.currentPlayingVideo = null;
    }
  }
  reset() {
    this.currentPage = 1;
    this.searchFormGroup.reset();
    this.searchFormGroup = this.createSearchForm();
    this.applyFilter();
  }

  searchFormGroup: FormGroup = this.createSearchForm();
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: ['', data?.search],
      type: ['', data?.type],
    });
  }
  listtuto: any;
  applyFilter(pageNumber : number = this.currentPage) {
    this.btnSearchactive = true;
    this.spinner.show();
    let data = {
      type: 2,
      search: this.searchFormGroup.value.search,
      per_page: this.pageSize,
      page: this.currentPage
    };
    this.spinner.show();
    this.tutoService
      .searchtuto(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => { 
          this.listTuto = res.data.items.data;
          console.log('tuto',this.listTuto)
          this.totalItems = res.data.items.total;
          this.spinner.hide();
          if (this.listTuto.length === 0) {
            this.noResults();
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastrService.error('Erreur serveur');
        },
      });
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
     if (this.searchFormGroup.dirty && this.btnSearchactive ) {
      this.applyFilter();
    } 
    else {
      this.getListTuto();
    }
  }
  noResults() {
    this.spinner.hide();
    this.listTuto = [];
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
